/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Turn off the header option and the first row is treated as data rather than column names, so each row is converted into a plain list of values instead of a keyed record. Turn it back on when the top row really is a header.`)
};

const es_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Desactiva la opción de encabezado y la primera fila se trata como datos en lugar de nombres de columna, por lo que cada fila se convierte en una lista simple de valores en lugar de un registro con claves. Actívalo de nuevo cuando la fila superior realmente sea un encabezado.`)
};

const de_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Deaktiviere die Kopfzeilen-Option, dann wird die erste Zeile als Daten statt als Spaltennamen behandelt, sodass jede Zeile in eine einfache Liste von Werten statt in einen benannten Datensatz umgewandelt wird. Aktiviere sie wieder, wenn die oberste Zeile tatsächlich eine Kopfzeile ist.`)
};

const nl_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Schakel de koptekstoptie uit en de eerste rij wordt behandeld als gegevens in plaats van kolomnamen, dus elke rij wordt geconverteerd naar een eenvoudige lijst met waarden in plaats van een record met sleutels. Schakel dit weer in wanneer de bovenste rij echt een koptekst is.`)
};

const fr_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Désactivez l'option d'en-tête et la première ligne est traitée comme des données plutôt que comme des noms de colonnes, donc chaque ligne est convertie en une liste simple de valeurs au lieu d'un enregistrement avec clés. Réactivez-la quand la première ligne est vraiment un en-tête.`)
};

const it_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Disattiva l'opzione intestazione e la prima riga viene trattata come dati anziché come nomi di colonna, quindi ogni riga viene convertita in un semplice elenco di valori invece di un record codificato. Riattivalo quando la riga superiore è davvero un'intestazione.`)
};

const pt_br2_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Desative a opção de cabeçalho e a primeira linha é tratada como dados em vez de nomes de coluna, então cada linha é convertida em uma lista simples de valores em vez de um registro nomeado. Ative-o novamente quando a linha superior for realmente um cabeçalho.`)
};

const pt_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Desative a opção de cabeçalho e a primeira linha é tratada como dados em vez de nomes de coluna, portanto cada linha é convertida em uma lista simples de valores em vez de um registo nomeado. Ative-a novamente quando a linha superior realmente for um cabeçalho.`)
};

const ja_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。ヘッダーオプションをオフにすると、最初の行はカラム名ではなくデータとして扱われるため、各行はキー付きレコードではなく値のプレーンなリストに変換されます。一番上の行が本当にヘッダーのときはオンに戻してください。`)
};

const zh_cj_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。关闭表头选项后，第一行会被当作数据而不是列名，这样每一行都会被转换为一组普通的值列表，而不是带键的记录。当顶部那一行确实是表头时，再重新开启该选项即可。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_faq4_a", locale)
	if (locale === "en") return en_cj_faq4_a(inputs)
	if (locale === "es") return es_cj_faq4_a(inputs)
	if (locale === "de") return de_cj_faq4_a(inputs)
	if (locale === "nl") return nl_cj_faq4_a(inputs)
	if (locale === "fr") return fr_cj_faq4_a(inputs)
	if (locale === "it") return it_cj_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_cj_faq4_a(inputs)
	if (locale === "pt") return pt_cj_faq4_a(inputs)
	if (locale === "ja") return ja_cj_faq4_a(inputs)
	return zh_cj_faq4_a(inputs)
};